// third party libs
import React from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import Typography from '@navi/web-ui/lib/primitives/Typography/index';
// functions and components
import LineLoader from 'src/components/SkeletonLoader/LineLoader';
import cx from 'classnames';
import CloseIcon from '@navi/web-ui/lib/icons/CloseIcon/index';
import SuspenseLoader from 'src/components/SkeletonLoader/SuspenseLoader';
import Overlay from 'src/components/Overlay/Overlay';
import { RootState } from 'src/store';
import { createKey } from 'src/utils/CaseDetail.utils';
import { IDisplayItems } from '../../interfaces/EmiSchedule.type';
import { getSanitizedEnumValue } from 'src/utils/commonUtils';
import {
  TRANSACTION_STATUS_MAP,
  TRANSACTION_STATUS_TYPE
} from '../../constants/communicationHistory.constant';
// styles
import styles from './index.module.scss';
import { addClickstreamEvent } from '../../../../service/clickStreamEventService';
import { CLICKSTREAM_EVENT_NAMES } from '../../../../service/clickStream.constant';
import { Button, Drawer } from '@navi/web-ui/lib/primitives';
import PresentEnachDrawer from './PresentEnachDrawer';
import Modal from '@cp/src/components/Modal/Modal';
import { DateFormat, formatDate } from '@cp/src/utils/DateHelper';

const EnachValueCard: React.FC<IDisplayItems> = props => {
  const { loanId = '', customerId = '' } = useParams();
  const details = useSelector(
    (state: RootState) => state.caseDetail.pageData?.[createKey(loanId, customerId)]?.details?.data
  );
  const isInternalTeamLead = useSelector((state: RootState) => state.common.isInternalTeamLead);
  const { color, header, value, monthlyEnach, boldPart } = props;
  const displayColor = color === 'red' ? styles.red : styles.black;
  const [openModal, setOpenModal] = React.useState(false);
  const [openPresentEnach, setOpenPresentEnach] = React.useState(false);

  if (!Array.isArray(monthlyEnach)) {
    return null;
  }

  const toggleHistoryModal = () => {
    setOpenModal(!openModal);
  };

  const togglePresentEnach = () => {
    setOpenPresentEnach(prev => !prev);
  };

  const isEnachPresent = monthlyEnach?.length;
  return (
    <>
      <div className={cx(styles.enachCardContainer, 'rr-block')}>
        <SuspenseLoader
          loading={!details}
          fallBack={
            <LineLoader
              numberOfLines={1}
              lineWidth={70}
              dimenshionUnit={'px'}
              childrenType={'H4'}
            />
          }
        >
          <div className={styles.enachValueContainer}>
            <Typography className={displayColor} variant={'h3'}>
              {typeof value !== 'function' ? value : details ? value(details) : ''}
            </Typography>
            <Typography as="span" className={styles.autoPayMonth} variant={'p5'}>
              {header} <strong>{boldPart}</strong>
            </Typography>
          </div>
        </SuspenseLoader>
        <div
          className={cx({
            [styles.bottomButtons]: isInternalTeamLead,
            [styles.notInternalTeamlead]: !isInternalTeamLead
          })}
        >
          <Button
            className={styles.presentEnachButton}
            variant="text"
            onClick={() => {
              toggleHistoryModal();
              addClickstreamEvent(CLICKSTREAM_EVENT_NAMES.LH_EMISchedule_AutoPayHistory);
            }}
          >
            Auto Pay History
          </Button>
        </div>
      </div>
      <Modal visible={openModal} onClose={toggleHistoryModal} header="Raise Enach request">
        <div className={styles.persentEnach}>
          <div className={cx(styles.flex, styles.modeOfContact)}>
            <Typography className={cx(styles.black)} variant={'h4'}>
              {typeof value !== 'function' ? value : details ? value(details) : ''}
            </Typography>
            <Typography className={cx([styles.greyScale2, styles.ml_16])} variant={'p3'}>
              {isEnachPresent ? 'Enach requests raised' : 'No Enach requests raised this month'}
            </Typography>
          </div>
          {isEnachPresent ? (
            <Typography className={styles.historyText} variant={'p4'}>
              History
            </Typography>
          ) : undefined}
          {monthlyEnach?.map(enach => (
            <div className={cx(styles.historyContainer)} key={enach.enachRequestRaisedOn}>
              <Typography className={styles.black} variant={'p4'}>
                {enach.enachRequestRaisedOn
                  ? formatDate(enach.enachRequestRaisedOn, DateFormat.LONG_DATE_FORMAT_WITHOUT_TIME)
                  : ''}
              </Typography>
              <Typography
                className={
                  TRANSACTION_STATUS_TYPE.FAILED === enach.enachRequestStatus
                    ? styles.red
                    : styles.green
                }
                variant={'p4'}
              >
                {getSanitizedEnumValue(TRANSACTION_STATUS_MAP, enach.enachRequestStatus)}
              </Typography>
            </div>
          ))}
        </div>
      </Modal>
      {openPresentEnach && (
        <PresentEnachDrawer open={openPresentEnach} onClose={togglePresentEnach} />
      )}
    </>
  );
};

export default EnachValueCard;
